import { render } from "./EditPersonalInfo.vue?vue&type=template&id=6127eb4b&scoped=true&lang=pug"
import script from "./EditPersonalInfo.vue?vue&type=script&lang=js"
export * from "./EditPersonalInfo.vue?vue&type=script&lang=js"

import "./EditPersonalInfo.vue?vue&type=style&index=0&id=6127eb4b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6127eb4b"]])

export default __exports__